import { WritableDraft } from 'immer';

import { QuoteBuilderStateType } from '../../types/state';

export function dialogClosed(state: WritableDraft<QuoteBuilderStateType>) {
  state.dialog = null;
}
